import createComponent from '../components/library_links/main.js';

$(() => {
    const target = document.querySelector('.js-members-container');
    createComponent({target});
});
